<div class="page-content container" *ngIf="user">
  <app-profile-settings-header [uploadEnabled]="false" [user]="user!" [showActions]="false"></app-profile-settings-header>
  <app-content-list [author]="user!" [showPagination]="true" [showContentTypeFilter]="true" title="Utwory użytkownika"></app-content-list>
</div>
